/**
 * 埋点使用方式
 * v-stat:
 * 使用依赖入驻的方式，使得该方法具有一定的复用性
 */
import Expousure from './exposure';
const expousure = new Expousure();
const CLICK_NAME = 'click';
const SHOW_NAME = 'show';
function _createAttributeName (arg) {
  const key = 'data-stat-' + arg;
  return key;
}
const createStatDirective = function (track) {
  const stat = {
    name: 'stat',
    bind: function (el, binding, vnode) {
      if (!stat.setAttribute(el, binding, vnode)) {
        return;
      }
      if (binding.arg === CLICK_NAME) {
        // el.addEventListener(CLICK_NAME, function () {
        //   const key = _createAttributeName(CLICK_NAME);
        //   const value = el.getAttribute(key);
        //   if (!value) {
        //     return;
        //   }
        //   stat.track(JSON.parse(value), vnode.context.$root);
        // });
      } else if (binding.arg === SHOW_NAME) {
        if (!expousure._context) {
          expousure._context = vnode.context;
        }
        expousure.attach(el, binding.modifiers.once);
      }
    },
    setAttribute (el, binding, vnode) {
      if (!binding.arg) {
        console.warn('vue-stat can\'t find arg,to be click or show');
        return false;
      }
      const name = _createAttributeName(binding.arg);
      el.setAttribute(name, JSON.stringify(binding.value));
      return true;
    },
    update: function (el, binding, vnode) {
      const name = _createAttributeName(binding.arg);
      let oldValue = el.getAttribute(name);
      stat.setAttribute(el, binding, vnode);
      if (binding.arg === SHOW_NAME) {
        let newValue = el.getAttribute(name);
        if (oldValue !== newValue) { stat.showTrack(el); }
        return;
      }
    },
    inserted: function (el, binding, vnode) {
      if (!binding.arg || binding.arg === SHOW_NAME || binding.arg === CLICK_NAME) {
        return;
      }
      stat.track(binding.value, vnode.context.$root);
    },
    showTrack (el) {
      const key = _createAttributeName(SHOW_NAME);
      const value = el.getAttribute(key);
      console.log('触发曝光事件', value);
      if (!value) {
        return;
      }
      let val = JSON.parse(value);
      if (!val.basic) {
        val.basic = { type: 'show' };
      } else if (val.basic.type) {
        val.basic.type = 'show';
      }
      stat.track(val, this.context ? this.context.$root : null);
    },
    unbind (el, binding, vnode) {
      if ((!el.__exposure_once ||
        (el.__exposure_once && !el.__exposure_onced)) &&
        binding.arg === SHOW_NAME) {
        expousure.detach(el);
      }
    },
    track (data, _vue) {
      try {
        data.basic = data.basic || {};
        if (!data.basic.type) {
          data.basic.type = 'click';
        }
        track(data, _vue);
      } catch (err) {
        console.error(err);
      }
    }
  };
  expousure.notify(stat.showTrack);
  return stat;
};

export default createStatDirective;
